<template>
  <div id="app">
    <router-view />
    <loading v-show="show"></loading>
  </div>
</template>

<script>
import storage from './utils/storage'
import axios from 'axios'
import wx from 'weixin-js-sdk'
import Loading from './components/Loading'
import { Dialog } from 'vant'

export default {
  name: 'app',
  components: {
    [Dialog.name]: Dialog,
    Loading
  },
  data() {
    return {
      show: false
    }
  },
  created() {
    // 微信相关配置
    let ua = window.navigator.userAgent.toLowerCase()
    let isWeixin = ua.indexOf('micromessenger') > 0
    if (isWeixin) {
      let url = window.location.href.split('#')[0]
      this.$http
        .get(global.GET_WEIXIN_SIGN, {
          params: {
            url: url
          }
        })
        .then(
          async response => {
            if (!response.data.success) {
              return
            }
            let returnData = response.data
            if (returnData.success) {
              let wxData = returnData.data
              // 微信配置
              await wx.config({
                debug: false,
                appId: wxData.appId,
                timestamp: wxData.timeStamp,
                nonceStr: wxData.noncestr,
                signature: wxData.signature,
                jsApiList: [
                  'updateAppMessageShareData',
                  'updateTimelineShareData',
                  'onMenuShareAppMessage',
                  'onMenuShareTimeline'
                  // 'onMenuShareTimeline',
                  // 'onMenuShareAppMessage',
                  // 'onMenuShareQQ',
                  // 'onMenuShareWeibo',
                  // 'onMenuShareQZone',
                  // 'hideMenuItems',
                  // 'chooseImage',
                  // 'previewImage',
                  // 'uploadImage',
                  // 'downloadImage'
                ]
              })
              await wx.ready(() => {
                wx.onMenuShareAppMessage({
                  title: 'Affiliate Program', //分享的标题, //分享的标题
                  desc: 'MyQC Inspection Services', //分享的描述
                  link: 'http://club.tradeaider.com/#/', //分享的链接
                  imgUrl: 'https://static.tradeaider.com/agreement/share-club-logo.png', //分享的图片链接
                  success: function() {}
                })
                wx.onMenuShareTimeline({
                  title: 'Affiliate Program', //分享的标题, //分享的标题
                  desc: 'MyQC Inspection Services', //分享的描述
                  link: 'http://club.tradeaider.com/#/', //分享的链接
                  imgUrl: 'https://static.tradeaider.com/agreement/share-club-logo.png', //分享的图片链接
                  success: function() {}
                })
              })
            }
          },
          error => {}
        )
    }

    let that = this
    axios.interceptors.request.use(
      function(config) {
        // 如果需要登录后才能访问的，需要添加头信息
        let userToken = storage.getSessionStorage('user') || storage.getLocalStorage('user')
        // let partnerToken = store.state.user.partnerToken
        that.show = true
        if (userToken) {
          config.headers.common['uid'] = userToken.uid
          config.headers.common['token'] = userToken.token
          config.headers.common['appType'] = '8'
          // console.log(config.headers)
        } else {
          if (that.$route.meta.auth) {
            that.$router.replace({ name: 'activity' })
          }
        }
        return config
      },
      function(error) {
        // Do something with request error
        return Promise.reject(error)
      }
    )
    // axios回调配置
    axios.interceptors.response.use(
      function(response) {
        // Do something with response data
        that.show = false
        if (response.data.statusCode === 1) {
          Dialog.alert({
            message: response.data.msgEN
          }).then(() => {
            // on close
          })
        }
        if (response.data.statusCode === 2) {
          Dialog.alert({
            message: 'Login expired, please log in again',
            confirmButtonText: 'confirm'
          }).then(() => {
            // on close
            storage.clearLocalStorage()
            storage.clearSessionStorage()
            that.$router.replace({ name: 'login' })
          })
        }
        return response
      },
      function(error) {
        // Do something with response error
        return Promise.reject(error)
      }
    )
  }
}
</script>

<style>
@media (max-width: 750px) {
  #app {
    width: 100%;
    height: 100%;
  }
  .mint-loadmore-bottom span {
    display: inline-block;
    transition: 0.2s linear;
    vertical-align: middle;
    font-size: 0.6rem;
    color: rgba(0, 0, 0, 0.5);
  }

  .mint-loadmore-bottom rotate {
    transform: rotate(180deg);
  }
}
@media (min-width: 750px) {
  #app {
    width: 750px;
    min-height: 100%;
    margin: 0 auto;
  }
  .mint-loadmore-bottom span {
    display: inline-block;
    transition: 0.2s linear;
    vertical-align: middle;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.5);
  }

  .mint-loadmore-bottom rotate {
    transform: rotate(180deg);
  }
}
a:focus {
  outline: none;
}
</style>
